import React from 'react';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import OurSuccessGuarantee from './OurSuccessGuarantee/OurSuccessGuarantee';
import Problems from './Problems/Problems';
import BaseSectionWithImage from 'commonComponents/sections/BaseSectionWithImage/BaseSectionWithImage';
import QuoteAndPhoto from 'commonComponents/QuoteAndPhoto/QuoteAndPhoto';
import StepsSection from './StepsSection/StepsSection';
import Squares from './Squares/Squares';
import CirclePhotoAndQuote from 'commonComponents/CirclePhotoAndQuote/CirclePhotoAndQuote';
import Consultants from 'commonComponents/Consultants/Consultants';
import TextWithImages from 'commonComponents/sections/TextWithImages/TextWithImages';
import SectionWithBoxes from 'commonComponents/sections/SectionWithBoxes/SectionWithBoxes';
import TileWithIcon from 'commonComponents/tiles/TileWithIcon/TileWithIcon';
import Processes from './Processes/Processes';
import Questions from './Questions/Questions';
import SectionWithColumns from 'commonComponents/sections/SectionWithColumns/SectionWithColumns';
import { importConsultantsPhotos } from 'lib/utils/imagesUtils';

import {
  SmartSalesLogo, logos, firstStepsIcons, overviewImages,
  house, CustomerPhoto, Steps
} from './images';

import styles from '../pages.module.scss';
import smartSalesStyles from './SmartSalesPage.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const SmartSalesPage = ({
  locale, banner, ourSuccessGuarantee,
  concept, ourCustomers, problems, steps,
  experts, strategy, firstSteps, processes,
  questions, overview, funnelLink, subpageLink, processLink
}) => {
  ourSuccessGuarantee.boxes.forEach((box, i) => box.logo = logos[i]);
  const conceptProps = {
    ...concept,
    button: {
      label: concept.button,
      link: funnelLink,
    },
    image: house(locale)
  };

  const ourCustomersProps = {
    ...ourCustomers,
    button: {
      label: ourCustomers.button,
      link: '/customer-stories',
    },
    photo: CustomerPhoto
  };

  const problemsProps = {
    ...problems,
    button: {
      label: problems.button,
      link: '*'
    }
  };

  const stepsProps = { ...steps };
  const { list } = stepsProps;
  const { squares } = list[1];
  stepsProps.link.url = funnelLink;

  const consultantsPhotos = importConsultantsPhotos();
  const photo = consultantsPhotos['Andre-Torkler'];

  list[0].graphics = <img src={ Steps[0] } />;
  const path = locale == 'en' ? 'real-estate-valuation' : 'immobilienbewertung';
  list[0].link.url = `/services/smart-sales/${path}`;
  list[1].graphics = <Squares squares={ squares } />;
  list[2].graphics = <CirclePhotoAndQuote { ...list[2].quote } photo={ photo } />;
  list[2].link.url = subpageLink;
  list[3].graphics = <img src={ Steps[1] } />;
  list[4].graphics = 
    <img src={ Steps[2] } width="200"
      height="253"
    />;
  list[4].link.url = processLink;

  const { name, position } = experts;
  const consultants = [
    { name: 'Hofmann Anton' },
    { name, position, isPrimary: true },
    { name: 'Andre Torkler' }
  ];

  const consultantsSection = 
    <Consultants { ...experts } link={ funnelLink }
      consultants={ consultants }
    />;

  const context = require.context('oldAssets/images/static_pages/smart_sales', false, /ss_photo_\d\.webp$/);

  const firstStepsProps = { ...firstSteps };

  firstStepsProps.button.link = funnelLink;
  firstStepsProps.boxes.forEach((box, i) => box.icon = firstStepsIcons[i]);
  firstStepsProps.boxRender = (box, number) => {
    const boxProps = {
      ...box,
      title: `${number}. ${box.title}`,
      key: number,
      number,
      description: <p className={ smartSalesStyles.description }>{ box.text }</p>
    };

    return <TileWithIcon { ...boxProps } />;
  };

  const overviewTiles = Object.values(overview.tiles);
  const overviewProps = { ...overview, tiles: overviewTiles };
  overviewProps.tiles.forEach((item, i) => item.photo = overviewImages[i]);

  const questionsProps = { ...questions };
  questionsProps.button.link = '/faq';

  const bannerProps = {
    ...banner,
    logo: SmartSalesLogo,
    pageName: 'smartSales',
    button: {
      label: banner.button,
      link: funnelLink
    }
  };

  const processesProps = { ...processes };
  processesProps.button.link = subpageLink;

  return (
    <div className={ styles.Page }>
      <StageWithText { ...bannerProps } />
      <OurSuccessGuarantee { ...ourSuccessGuarantee } />
      <BaseSectionWithImage
        { ...conceptProps }
        anchor='concept'
      />
      <QuoteAndPhoto { ...ourCustomersProps } />
      <Problems { ...problemsProps } />
      <StepsSection logo={ SmartSalesLogo } { ...steps } />
      { consultantsSection }
      <section></section>
      <SectionWithColumns { ...overviewProps } />
      <TextWithImages
        { ...strategy }
        context={ context }
        anchor='after-sales-strategy'
      />
      <SectionWithBoxes
        { ...firstStepsProps }
        anchor='first-steps'
      />
      <Processes { ...processesProps } />
      { consultantsSection }
      <Questions { ...questionsProps } />
    </div>
  );
};

export default SmartSalesPage;
